import { render, staticRenderFns } from "./StockMovementTable.vue?vue&type=template&id=16bf959b&scoped=true"
import script from "./StockMovementTable.vue?vue&type=script&lang=js"
export * from "./StockMovementTable.vue?vue&type=script&lang=js"
import style0 from "./StockMovementTable.vue?vue&type=style&index=0&id=16bf959b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf959b",
  null
  
)

export default component.exports